import React, { useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ProfessionalServiceProduct({ 
  image, 
  name, 
  id, 
  selectionMode = false, 
  onSelect 
}) {
  const navigate = useNavigate();

  // Optimized selection mode card (Mirrors Material Store's premium look)
  if (selectionMode) {
    return (
      <Card
        sx={{
          width: "100%",
          background: "#FBFAF7",
          borderRadius: 3,
          boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
          cursor: "pointer",
          transition: "transform 0.2s",
          "&:hover": { transform: "translateY(-4px)" },
          textAlign: "center",
          p: 2,
        }}
        onClick={() => onSelect && onSelect(id, name)}
      >
        <Box
          sx={{
            width: "100%",
            height: 150,
            borderRadius: 2,
            overflow: "hidden",
            border: "1px solid #95B160", // Consistent signature border
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            mb: 1.5,
          }}
        >
          <Box
            component="img"
            src={(Array.isArray(image) ? image[0] : image) || "/assets/images/placeholder_img.png"}
            alt={name}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: image ? "cover" : "contain",
              p: image ? 0 : 2,
            }}
          />
        </Box>
        <Typography variant="subtitle1" fontWeight={600} noWrap sx={{ color: "#000" }}>
          {name || "Service"}
        </Typography>
      </Card>
    );
  }

  // Fallback for non-selection mode (if ever used)
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        height: "100%",
        borderRadius: 3,
        cursor: "pointer",
        background: "#FBFAF7",
        boxShadow: "0px 4px 14px rgba(0,0,0,0.12)",
        transition: "all 0.25s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0px 12px 30px rgba(0,0,0,0.22)",
        },
      }}
      onClick={() => navigate(`/professional-services/services/${id}`)}
    >
      <Box
        sx={{
          width: "100%",
          height: 200,
          borderBottom: "1px solid #E5E5E5",
          overflow: "hidden"
        }}
      >
        <Box
          component="img"
          src={(Array.isArray(image) ? image[0] : image) || "assets/images/placeholder_img.png"}
          alt={name}
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>

      <CardContent sx={{ width: "100%", py: 2 }}>
        <Typography variant="body2" fontWeight={600} sx={{ color: "#000" }}>
          {name || ""}
        </Typography>
      </CardContent>
    </Card>
  );
}
